import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationLib, RedirectionUtilityLib } from '../util';

/**
 *  This class execute on event url change and authenticate user to access the application.
 *
 * @export
 * @class AuthenticationGuard
 * @implements {CanActivate}
 * @implements {CanActivateChild}
 */
@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(
    private authenticationLib: AuthenticationLib,
    private router: Router,
    private redirectionUtilityLib: RedirectionUtilityLib,
  ) {}

  /**
   *  This method is used for authenticate the route
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {boolean}
   *
   * @memberOf AuthenticationGuard
   */
  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    // check the active user session
    if (this.authenticationLib.authorizedRoute()) {
      return true;
    }
    url = this.getLoginUrl(url);
    let queryObject = {};
    if (url) {
      queryObject = { redirectUrl: url };
    }

    this.router.navigate(['/login'], { queryParams: queryObject });
    return false;
  }

  private getLoginUrl(url: string): string {
    if (url) {
      this.redirectionUtilityLib.setRedirectUrl(url);
      return url;
    } else {
      return '';
    }
  }
}

export const canActivateAuthentication: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AuthenticationGuard).canActivate(route, state);
};
